import Accordion from "components/blocks/Accordion";
import AccordionItem from "components/blocks/Accordion/AccordionItem";
import AttachmentCard from "components/blocks/AttachmentCard";
import FormInput from "components/blocks/FormInput";
import {useTranslation} from "react-i18next";
import {CourseOrderLocalItemResult} from "../../../../../../../services/courseOrder/models/CourseOrderType";
import {useQuery} from "../../../../../../../hooks/useQuery";
import {BackendServices} from "../../../../../../../services";
import {SettingKeys} from "../../../../../../../services/settingService/models/SettingTypes";

const Rewards = ({order}: { order: CourseOrderLocalItemResult | null }) => {
    const {t} = useTranslation("Orders");
    const {data: examiner} = useQuery({
        queryFn: async () => {
            return await BackendServices.settingsService.getSettingValue(SettingKeys.ExaminerRewards);
        },
    });
    const {data: referee} = useQuery({
        queryFn: async () => {
            return await BackendServices.settingsService.getSettingValue(SettingKeys.RefereeRewards);
        },
    });
if(order?.authorAmount)
    return (
        <>
             <Accordion>
                <AccordionItem initiallyOpen title={t("rewards")} elementId={"rewards"}>
                    <div className="d-flex gap-2 flex-wrap">
                        <FormInput
                            label={t("authorRewardAmount")}
                            disabled
                            leftElement={<span className="text-primary">{t("ryal")}</span>}
                            value={order?.authorAmount}
                        />
                        { order?.courseOrderEvaluation?.evaluationFormId &&   <FormInput
                            label={t("examinerRewardAmount")}
                            disabled
                            leftElement={<span className="text-primary">{t("ryal")}</span>}
                            value={examiner?.value}
                        />}
                        { order?.courseOrderEvaluation?.refereeEvaluationFormId &&   <FormInput
                            label={t("judgeRewardAmount")}
                            disabled
                            leftElement={<span className="text-primary">{t("ryal")}</span>}
                            value={referee?.value}
                        />}
                    </div>


                    <div className="divider mt-4 "></div>
                </AccordionItem>
            </Accordion>
        </>
    );
else return <></>;
};

export default Rewards;
